import { axios } from '@/lib/axios'
import { createFormData } from '@/utils/api.util'

class OfferActionService {
  constructor() {
    this.resource = 'offers'
  }

  adminEditOffer = async ({ offerId, ...data }) => {
    const response = await axios.put(`${this.resource}/${offerId}/adminEdit`, data)
    return response.data
  }

  reviseOffer = async ({ offerId, ...data }) => {
    const payload = createFormData(data)
    console.log(data)
    const response = await axios.post(`${this.resource}/revise/${offerId}`, payload)
    return response.data
  }

  activateOffer = async ({ offerId }) => {
    const response = await axios.put(`${this.resource}/${offerId}/activate`)
    return response.data
  }

  cloneOffer = async ({ offerId, salesId }) => {
    const response = await axios.post(`${this.resource}/${offerId}/clone`, { salesId })
    return response.data
  }

  renewOffer = async ({ offerId, salesId, subSystemIndex }) => {
    const response = await axios.post(`${this.resource}/${offerId}/renew`, { salesId, subSystemIndex })
    return response.data
  }

  createOfferBooking = async ({ offerId }) => {
    const response = await axios.put(`${this.resource}/${offerId}/createBooking`)
    return response.data
  }

  noticeCurrentApprover = async ({ offerId }) => {
    const response = await axios.put(`${this.resource}/${offerId}/noticeCurrentApprover`)
    return response.data
  }

  addCustomerToOffer = async ({ offerId }) => {
    const response = await axios.post(`${this.resource}/${offerId}/addCustomer`)
    return response.data
  }
  uncloseOffer = async ({ offerId }) => {
    const response = await axios.post(`${this.resource}/${offerId}/unclose`)
    return response.data
  }

  toggleOfferRenewalLost = async ({ offerId, data }) => {
    const response = await axios.put(`${this.resource}/${offerId}/toggleRenewalLost`, data)
    return response.data
  }

  removeOfferFile = async ({ id, fileType, fileId }) => {
    const response = await axios.delete(`${this.resource}/${id}/files/${fileType}/${fileId}`)

    return response.data
  }
}

export default OfferActionService
